import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {sendRequest} from "../../../utils/request";
import {ComponentName} from "../../../utils/formatters";
import unparseQuery from "../forms/NewsLetter/QueryBuilder/unparseQuery";
import parseQuery from "../forms/NewsLetter/QueryBuilder/parseQuery";
import removeEmpty from "../forms/NewsLetter/QueryBuilder/removeEmpty";

class Targets extends React.Component {

    state = {
        sendTo: null
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(this.props.values.filter) !== JSON.stringify(prevProps.values.filter)) {
            this.loadList();
        }
    }

    componentDidMount() {
        this.loadList();
    }

    loadList = () => {
        if (this.props.values.component) {
            let filter = null;
            if (this.props.values.filter) {
                filter = parseQuery(unparseQuery(this.props.values.filter));
                if (!removeEmpty(filter)) {
                    filter = null;
                }
            }
            this.targets = sendRequest({
                option: "componentlist",
                component: this.props.values.component,
                filter,
                group: {by: "email"},
                itemsperpage: 1,
            }, {showError: false});
            this.targets.then((response) => {
                this.setState({
                    sendTo: parseInt(response.fullcount)
                });
            });
        }
    }

    render() {
        return this.state.sendTo === null ? "..." : this.state.sendTo;
    }
}

class NewsletterTargetList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "NewsletterTargetList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {header: 'Kód', width: 6, sortable, filterable},
                    "component": {
                        header: 'Címzettek',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "filter": {
                        header: 'Feliratkozottak',
                        width: 3,
                        renderer: (v, rowData) => <Targets values={rowData} />
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default NewsletterTargetList;
